module.exports = __webpack_public_path__ + "img/Swap-Envoy-Order.3a74963f.png";